import React, { useEffect, useState } from 'react'
import CoinWalletCard from '../components/globals/CoinWalletCard'
import walimage1 from '../assets/images/wallet-1.png'
import walimage2 from '../assets/images/wallet-2.png'
import walimage3 from '../assets/images/wallet-3.png'
import { apiGetAuth, apiPost } from '../utils/Api'
import { ENDPOINTS } from '../utils/EndPoint'
import TableComponent from '../components/globals/TableComponent'
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton'
import CustomSecondaryButton from '../components/globals/CustomSecondaryButton';
import { userAtom } from '../store/authAtom'
import { useRecoilState } from 'recoil'
import CustomModal from '../components/globals/CustomModal'
import { useNavigate } from 'react-router-dom'

function Wallet() {

  // const data = [
  //   { id: 4, date: '2022-01-02', time: '10:00 AM', coin_type: 'Shark', coin_type: 'Debit', amount: '12', transaction_type: '23423' },
  //   { id: 5, date: '2022-01-02', time: '10:00 AM', coin_type: 'Shark', coin_type: 'Debit', amount: '12', transaction_type: '23423' },
  //   { id: 6, date: '2022-01-02', time: '10:00 AM', coin_type: 'Shark', coin_type: 'Debit', amount: '12', transaction_type: '23423' },
  //   { id: 7, date: '2022-01-02', time: '10:00 AM', coin_type: 'Shark', coin_type: 'Debit', amount: '12', transaction_type: '23423' },
  //   { id: 8, date: '2022-01-02', time: '10:00 AM', coin_type: 'Shark', coin_type: 'Debit', amount: '12', transaction_type: '23423' },
  // ];

  const [totalCoins, setTotalCoins] = useState([]);
  const [transaction, setTransactionHistory] = useState([]);
  const [showGuestModal, setGuestModal] = useState(false);
  const [user, setUser] = useRecoilState(userAtom);
  const navigate = useNavigate();


  const getTotalCoins = () => {
    apiGetAuth(
      ENDPOINTS.TotalCoins,
      (res) => {
        if (res) {
          console.log(res, "resresres");
          setTotalCoins(res);
        }
      },
      (error) => {
        console.log(error, "Challenges Year Bar");
      }
    );
  };

  useEffect(() => {
    if (totalCoins) {
      setGuestModal(true);
    }
  }, [totalCoins]);

  const getTransactionHistory = () => {
    apiPost(
      ENDPOINTS.GetTransactionHistory,
      (res) => {
        if (res) {
          console.log(res, "resresres");
          setTotalCoins(res);
          setTotalCoins(res);
        }
      },
      (error) => {
        console.log(error, "Challenges Year Bar");
      }
    );
  };


  useEffect(() => {
    getTotalCoins();
    getTransactionHistory();
  }, []);

  const columns = [
    {
      name: 'Coins',
      selector: (row) => row?.amount,
      sortable: false,
    },
    {
      name: 'Transaction Type',
      selector: (row) => (row?.badge == null ? row?.transaction_type_label : `${row?.badge?.goal_name + ' (Badge)'}`),
      sortable: false,
    },
    {
      name: 'Date & Time',
      selector: (row) => new Date(row?.created_at).toLocaleString(),
      sortable: false,
    },
  ];


  return (
    <>
      <div className='coin-wallet'>
        <div className='container'>
          <h1 className='pt-4 text-white'>Coin Wallet:</h1>
          <div className='row mt-5 justify-content-center'>
            <div className='col-lg-6 col-sm-12 col-xl-6 mb-2'>
              <CoinWalletCard
                wallettext="Total Balance Of Coins"
                walletamount={totalCoins.total_user_coins + ` Coins`}
                walletimage={walimage3}
              />
            </div>
            <div className='col-lg-6 col-sm-12 col-xl-6 mb-2'>
              <div className='custom-wallet custom-font'>
                <div className='custom-height-breakdown'>
                  <p className='skranji-bold'>Coins breakdown detail</p>
                  <ul className='list-unstyled'>
                    <li>When a user creates an account, they are awarded 200 SharkCoins</li>
                    <li>A stage costs 10 SharkCoins to enter</li>
                    <li>A user is awarded 20 SharkCoins if they pass a stage</li>
                    <li>A challenge costs 10 SharkCoins to enter</li>
                    <li>A quest cost 10 SharkCoins to enter</li>
                    <li>A user is awarded 20 SharkCoins if they pass a quest</li>
                    <li>SharkCoins are awarded for completing badges which can be viewed in the profile section</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='col-lg-6 col-sm-12 col-xl-6 mb-2'>
              <div className='custom-wallet custom-font'>
                <div>
                  <p className='skranji-bold'>Earn Coins</p>
                  <ul>
                    <li>200 Coins for creating an account</li>
                    <li>20 Coins for passing a mini quiz</li>
                    <li>Various Coins earned for badges</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='col-lg-6 col-sm-12 col-xl-6 mb-2'>
              <div className='custom-wallet custom-font justify-content-start'>
                <div>
                  <p className='skranji-bold'>Spend Coins</p>
                  <ul>
                    <li>10 Coins to enter a stage</li>
                    <li>10 Coins to enter a challenge</li>
                    <li>10 Coins to enter a quest</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className='transaction-history-div d-flex justify-content-between align-items-center'>
            <h2 className='pt-4 text-white'>Transaction History:</h2>
            <div className='custom-wallet custom-font'>
              <p className="skranji-bold m-0">
                Total Coins Earned: {totalCoins?.total_user_coins - (200 - totalCoins?.total_spending_coins)} Coins
              </p>

            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <TableComponent
                title={"Transaction History"}
                endPoint={ENDPOINTS.GetTransactionHistory}
                headers={columns}
                className="transaction-history"
                customTableClass="custom-wallet-table"
              />
            </div>
          </div>

        </div>
      </div>

      {user?.type === "guest_user" && (
        <CustomModal
          size="md"
          hideModal={() => navigate("/admin/ocean")}
          showModal={showGuestModal}
          title="Select Ocean"
        >
          <div className="ocean-modal text-center">
            <h2 className='text-white font-24 text-bold skranji-regular'>This feature is not available for guest users</h2>
            <div class="buttons d-flex justify-content-center">
              <CustomSecondaryButton
                btnTextPro="Cancel"
                classNamePro="btn btn-seondary"
                handleOnClick={() => navigate("/admin/ocean")}
              />
              <CustomPrimaryButton
                btnTextPro="Sign Up"
                classNamePro="btn btn-primary mt-2"
                handleOnClick={() => {
                  navigate("/register-form");
                }}
              />
            </div>
          </div>
        </CustomModal>
      )}
    </>
  )
}

export default Wallet